import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerBodyInlineStyles = /*#__PURE__*/function () {
  function BlockerBodyInlineStyles() {
    _classCallCheck(this, BlockerBodyInlineStyles);
  }

  _createClass(BlockerBodyInlineStyles, null, [{
    key: "bodyContainer",
    value: function bodyContainer(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          _ref$design = _ref.design,
          bg = _ref$design.bg,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          padding = _ref.bodyDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker,
          showFooter = _ref.showFooter;
      var style = {
        background: bg,
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        borderRadius: !showFooter && type === "dialog" ? "0 0 ".concat(dialogBorderRadius, "px ").concat(dialogBorderRadius, "px") : undefined,
        lineHeight: 1.4,
        overflow: "auto" // See https://stackoverflow.com/a/27829422/5506547

      };

      if (type === "dialog" && borderWidth > 0) {
        style.borderLeft = "".concat(borderWidth, "px solid ").concat(borderColor);
        style.borderRight = style.borderLeft;

        if (!showFooter) {
          style.borderBottom = style.borderLeft;
        }
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body-container",
        style: style
      };
    }
  }, {
    key: "body",
    value: function body(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var style = {
        margin: "auto"
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body",
        style: style
      };
    }
  }, {
    key: "description",
    value: function description(_ref3) {
      var fontSize = _ref3.design.fontSize,
          _ref3$bodyDesign = _ref3.bodyDesign,
          descriptionInheritFontSize = _ref3$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref3$bodyDesign.descriptionFontSize,
          descriptionTextAlign = _ref3.individualLayout.descriptionTextAlign,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-description",
        style: {
          marginBottom: 10,
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          textAlign: descriptionTextAlign
        }
      };
    }
  }]);

  return BlockerBodyInlineStyles;
}();

export { BlockerBodyInlineStyles };